import DdSubHeader from '@/components/DdSubHeader'
import DdTextArea from '@/components/DdTextArea'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'

import flowMixin from '@/mixins/flowMixins'
import Logger from '@/rahmen/logger'
import effects from '@/rahmen/utils/effects'
import HttpClient from '@/rahmen/httpClient'

import VueMarkdown from 'vue-markdown'
import { mapGetters } from 'vuex'

export default {
  name: 'DashBoard',
  mixins: [flowMixin],
  data: () => ({
    rec1: {
      oshiraseShosai: '',
      hasseimotoKbn: '',
      updUserId: '',
      updDate: ''
    },
    rec2: {
      oshiraseShosai: '',
      hasseimotoKbn: '',
      updUserId: '',
      updDate: ''
    },
    OshiraseUpdateButtonDisp: false,
    SystemOshiraseUpdateButtonDisp: false,
    vmd2Col1: 12,
    vmd2Col2: 0,
    vmd2EditFlg: false
  }),
  components: {
    DdSubHeader,
    DdTextArea,
    DdFooterButton,
    DdIconButtonWithTooltip,
    VueMarkdown
  },
  computed: {
    ...mapGetters({
      userId: 'users/userId',
      kengenGroupCd: 'users/kengenGroupCd'
    })
  },
  created () {
    effects.loadStart()
    this.$store.dispatch('system/setViewTitle', 'トップメニュー')
    console.log('DashBoard.Created', this.$router)
  },
  mounted () {
    this.logger = new Logger('token', 'name')
    this.logger.debug('DashBoard.mounted', { loginId: this.loginId, password: this.password })
    window.setTimeout(effects.loadComplete, 1000)
    this.initialize()
    this.settingButtonState()
  },
  methods: {
    initialize: function (e) {
      console.log('initialize')
      effects.loadStart()
      this.$store.dispatch('DDMasters/restoreMasters')
      this.$store.dispatch('DDMasters/loadMenuOshirase', { userId: this.userId }).then(() => {
        this.setOshiraseMessage()
      })
      effects.loadComplete()
    },
    settingButtonState: function (e) {
      console.log('settingButtonState')
      if (this.kengenGroupCd === '01') {
        this.OshiraseUpdateButtonDisp = true
        this.SystemOshiraseUpdateButtonDisp = true
      }
    },
    setOshiraseMessage: function () {
      this.$store.dispatch('DDMasters/getOshiraseMessage', '02').then((param) => {
        this.rec1.oshiraseShosai = param.oshiraseShosai
        this.rec1.updDate = param.updDate
      })
      this.$store.dispatch('DDMasters/getOshiraseMessage', '01').then((param) => {
        this.rec2.oshiraseShosai = param.oshiraseShosai
        this.rec2.updDate = param.updDate
      })
    },
    onClick: function () {
      effects.loadStart()

      window.setTimeout(effects.loadComplete, 3000)
    },
    onOshiraseUpdateButtonClick: function (e) {
      console.log('onOshiraseUpdateButtonClick')
      this.rec1.hasseimotoKbn = '02'
      this.register(this.rec1)
    },
    onSystemOshiraseUpdateButtonClick: function (e) {
      console.log('onSystemOshiraseUpdateButtonClick')
      this.rec2.hasseimotoKbn = '01'
      this.register(this.rec2)
      this.onNotificationClose()
    },
    register: function (param) {
      console.log('register')
      effects.loadStart()
      param.updUserId = this.userId
      const httpClient = new HttpClient()
      const posturl = '/api/v1/msysmenuoshirase/updatemessage'
      httpClient.post(posturl, param).then((data) => {
        if (data.isValid) {
          this.setInvalidSummaryMessage('COMI0002')
          effects.loadComplete()
          if (data.payload.hasseimotoKbn === '01') {
            this.rec2 = data.payload
          } else {
            this.rec1 = data.payload
          }
        } else {
          this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
          effects.loadComplete()
        }
      }).catch((data) => {
        console.error(data)
        this.setInvalidSummaryMessage('COMC9999')
        effects.loadComplete()
      })
    },
    onNotificationEdit: function () {
      this.vmd2Col1 = 6
      this.vmd2Col2 = 6
      this.vmd2EditFlg = true
    },
    onNotificationClose: function () {
      this.vmd2Col1 = 12
      this.vmd2Col2 = 0
      this.vmd2EditFlg = false
    }
  }
}
